import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MaskedInput } from '@/components/ui/masked-input';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

export const AddPartnerModal = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    company_name: '',
    telefone: '',
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const validateTelefone = (tel) => {
    const digits = tel.replace(/\D/g, '');
    return digits.length >= 10 && digits.length <= 11;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateTelefone(formData.telefone)) {
      toast.error('Telefone inválido. Use o formato (XX) XXXXX-XXXX');
      return;
    }
    
    setLoading(true);

    try {
      await axios.post(`${API}/users/partners`, formData, getAuthHeaders());
      toast.success('Parceiro adicionado com sucesso!');
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao adicionar parceiro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto" data-testid="add-partner-modal">
        <DialogHeader>
          <DialogTitle data-testid="add-partner-modal-title">Novo Parceiro</DialogTitle>
          <DialogDescription>Preencha os dados para criar uma conta de parceiro</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="add-partner-form">
          <div className="space-y-2">
            <Label htmlFor="name">Nome Completo <span className="text-destructive">*</span></Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              placeholder="Digite o nome completo"
              data-testid="partner-name-input"
              className="input-focus"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="company_name">Nome da Empresa <span className="text-destructive">*</span></Label>
            <Input
              id="company_name"
              value={formData.company_name}
              onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
              required
              placeholder="Ex: Empresa XYZ ou Autônomo"
              data-testid="partner-company-input"
              className="input-focus"
            />
            <p className="text-xs text-muted-foreground">
              <strong>Obrigatório:</strong> Se não tiver empresa, digite "Autônomo"
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="telefone">Telefone/WhatsApp <span className="text-destructive">*</span></Label>
            <MaskedInput
              id="telefone"
              mask="(99) 99999-9999"
              placeholder="(11) 99999-9999"
              value={formData.telefone}
              onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
              required
              data-testid="partner-telefone-input"
              className="input-focus"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email <span className="text-destructive">*</span></Label>
            <Input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              placeholder="email@exemplo.com"
              data-testid="partner-email-input"
              className="input-focus"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Senha <span className="text-destructive">*</span></Label>
            <Input
              id="password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              placeholder="••••••••"
              data-testid="partner-password-input"
              className="input-focus"
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 btn-transition"
              data-testid="cancel-partner-button"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="flex-1 btn-transition"
              data-testid="submit-partner-button"
            >
              {loading ? 'Criando...' : 'Criar Parceiro'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddPartnerModal;
